import { GlobeIcon } from 'de-suite-me-ui'

export default GlobeIcon
